export default "__VITE_PUBLIC_ASSET__e75e8f28__"